import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl, SmoothLink } from '@bd/bdcore-utilities';
import VideoPlayer from '@bd/bdui-videoplayer';
import VideoTitle from './VideoTitle';
import { colors, typography } from '../../styles';

const styles = css`
  padding: 70px 0 0 0;
  @media (min-width: 992px) {
    padding: 0;
  }
  .HeroImage_imageWrapper {
    background-size: cover;
    background-position: center center;
    width: 100vw;
    height: 50vh;
    position: relative;
    display: flex;
    align-items: center;
    @media (min-width: 992px) {
      height: calc(100vh - 80px);
    }
    &::after {
      content: '';
      position: absolute;
      display: block;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0,0,0,.2);
      z-index: 1;
    }
  }
  h2 {
    display: none;
    font-size: 36px;
    font-weight: 300;
    color: ${colors.white};
    font-family: ${typography.Serif};
    font-style: italic;
    text-shadow: 0 1px 2px rgba(0,0,0,.6);
    z-index: 2;
    position: relative;
    line-height: 1;
    text-transform:capitalize;
    @media(min-width: 1290px) {
      font-size: 82px;
    }
    span {
      display: inline-block;
      vertical-align: top;
      font-size: 42px;
      @media(min-width: 1290px) {
        font-size: 82px;
      }
    }
  }
  p {
    display: none;
    font-size: 28px;
    color: ${colors.white};
    text-shadow: 0 1px 2px rgba(0,0,0,.6);
    z-index: 2;
    position: relative;
  }
  .TitleDelay {
    display: block;
    justify-content: center;
  }
  .Welcome_arrow {
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 3;
    position: relative;
    z-index: 3;

    a {
      background-color: ${colors.white};
      border-radius: 50px;
      /* padding: 20px; */
      cursor: pointer;
      width: 102px;
      height: 102px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: -40px;

      img {
        width: 35px;
        height: 35px;
        margin: -20px 0 0 0;
      }
    }
  }
`;

const videoCSS = css`
  position: absolute;
  width: 100%;
  padding-top: 50vh;
  top: 0;
  z-index: 1;
  @media (min-width: 992px) {
    padding-top: calc(100vh - 80px);
  }
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

class HeroImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      headerImage: undefined,
    };
  }

  componentDidMount() {
    this.getHeaderImage();
  }

  getHeaderImage() {
    let { headerImage } = this.state;

    if (!headerImage) {
      headerImage = _.sample(_.get(this.props.page, 'header_images'));

      this.setState({
        headerImage: buildThumbnailUrl(_.get(headerImage, 'contentUrl'), { width: 2000, height: 2000 }),
      });
    }
  }

  render() {
    const { page } = this.props;
    const { headerImage } = this.state;


    return (
      <div className={styles}>
        {
          !_.get(page, 'header_video[0].video_file.contentUrl') &&
          <div
            className="HeroImage_imageWrapper"
            style={{ backgroundImage: `url('${headerImage}')` }}
          >
            <VideoTitle page={page} />
          </div>
        }
        {
          _.get(page, 'header_video[0].video_file.contentUrl') &&
          <div
            className="HeroImage_imageWrapper"
            style={{ backgroundImage: `url('${headerImage}')` }}
          >
            <VideoPlayer
              playing
              playsinline
              muted
              loop
              className={videoCSS}
              url={page.header_video[0].video_file.contentUrl}
            />
            <VideoTitle page={page} />
          </div>
        }
        <div className="Welcome_arrow">
          <SmoothLink href="#welcome">
            <img src="/images/arrow-down.svg" alt="Arrow Down" />
          </SmoothLink>
        </div>
      </div>
    );
  }
}

HeroImage.propTypes = {
  page: PropTypes.object.isRequired,
};

export default HeroImage;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HeroImage.js